'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentCheckAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 85 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 1.30005,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 5.3,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M72.7249 12.325H13.2749V45.675H72.7249V12.325Z", fill: "#D9DDE1" }),
      /* @__PURE__ */ jsx("path", { d: "M67.6499 23.2H53.1499V27.55H67.6499V23.2Z", fill: "white" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M47.3499 23.2H18.3499V24.65H47.3499V23.2ZM35.7499 39.15H18.3499V40.6H35.7499V39.15ZM18.3499 34.8H29.9499V36.25H18.3499V34.8ZM41.5499 27.55H18.3499V29H41.5499V27.55Z",
          fill: "#001018"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M73.4499 11.6H12.5499V17.4H73.4499V11.6Z", fill: "white" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M54.1723 35.5277L54.1681 35.5318C54.1291 35.5709 54.0784 35.6372 54.027 35.729C53.9767 35.8189 53.9357 35.916 53.9083 36.0041C53.8948 36.0474 53.8859 36.0845 53.8806 36.1138C53.878 36.1283 53.8765 36.1396 53.8758 36.1479C53.8749 36.1554 53.8749 36.1592 53.8749 36.1592C53.8749 36.5597 53.5503 36.8841 53.1499 36.8841C52.7496 36.8841 52.4249 36.5595 52.4249 36.1591C52.4249 35.7828 52.5762 35.3527 52.7615 35.0214C52.8596 34.8458 52.9859 34.6638 53.1414 34.5079C53.2919 34.357 53.5088 34.1914 53.7916 34.1208C54.7474 33.8818 55.4421 34.5902 55.7973 35.0552C56.1739 35.5482 56.4577 36.1421 56.6127 36.4666C56.6218 36.4856 56.6304 36.5036 56.6386 36.5207C56.754 36.7614 56.8281 37.0618 56.8845 37.3073C56.9056 37.3991 56.9251 37.4874 56.9441 37.5738C56.9829 37.7497 57.0198 37.9175 57.0651 38.0897C57.1313 38.3425 57.1989 38.5353 57.2711 38.6684C57.314 38.7476 57.3441 38.7785 57.3542 38.7876C57.4429 38.8201 57.4715 38.805 57.4827 38.7992L57.4846 38.7982C57.5227 38.7795 57.6022 38.7189 57.7 38.5617C57.8994 38.2414 58.0273 37.7593 58.0705 37.4179C58.0773 37.3646 58.0736 37.265 58.0476 37.0737C58.0425 37.0366 58.0364 36.994 58.0296 36.9477C58.0082 36.8001 57.9812 36.6148 57.9693 36.4483C57.9536 36.2272 57.9519 35.9189 58.0702 35.6197C58.2054 35.2775 58.4722 35.0098 58.8577 34.8748C59.89 34.5136 60.6757 35.1587 61.1341 35.6405C61.3387 35.8557 61.5332 36.0968 61.6987 36.3022C61.7291 36.34 61.7587 36.3766 61.7871 36.4116C61.988 36.659 62.1305 36.8216 62.2477 36.917C62.4118 37.0508 62.4956 37.0528 62.5226 37.0525C62.5697 37.0518 62.6567 37.0331 62.8195 36.935C62.9451 36.8593 63.0605 36.773 63.207 36.6635C63.2659 36.6196 63.3298 36.5717 63.4014 36.5194C63.6228 36.3576 63.9095 36.1601 64.2426 36.0352C64.6183 35.8944 65.2481 35.7297 65.8702 35.6977C66.1818 35.6816 66.5297 35.6964 66.8569 35.788C67.1864 35.8801 67.5493 36.0667 67.7928 36.4319C68.0149 36.765 67.9249 37.2152 67.5916 37.4374C67.2592 37.6589 66.8101 37.5698 66.5877 37.2381C66.5808 37.2318 66.551 37.208 66.4663 37.1843C66.3446 37.1503 66.1683 37.1342 65.945 37.1456C65.4971 37.1688 65.0143 37.2944 64.7517 37.3929C64.616 37.4438 64.4637 37.539 64.2571 37.6901C64.2166 37.7195 64.172 37.753 64.1243 37.7887C63.961 37.9109 63.761 38.0606 63.5679 38.1769C63.305 38.3352 62.958 38.4965 62.5435 38.5024C62.1089 38.5086 61.7035 38.3439 61.3317 38.0412C61.0814 37.8371 60.8506 37.5586 60.6614 37.3254C60.627 37.2832 60.5935 37.2416 60.5606 37.2009C60.3944 36.9951 60.2435 36.8082 60.0834 36.6399C59.7405 36.2794 59.5495 36.2095 59.4122 36.2255C59.4134 36.1798 59.4177 36.1583 59.4187 36.1531C59.4139 36.1653 59.4006 36.1902 59.3745 36.2153C59.3562 36.2329 59.3413 36.2408 59.3366 36.2432C59.3601 36.2349 59.3852 36.2287 59.4122 36.2255C59.4115 36.2549 59.412 36.2942 59.4157 36.3457C59.4234 36.4546 59.4386 36.5588 59.4574 36.6883C59.4658 36.746 59.475 36.8088 59.4845 36.8791C59.5105 37.0714 59.5421 37.3396 59.509 37.6002C59.4515 38.0539 59.2823 38.7637 58.9309 39.328C58.7533 39.6134 58.494 39.9182 58.1227 40.1003C57.7232 40.296 57.2713 40.3113 56.817 40.1347C56.403 39.9737 56.1511 39.6444 55.9969 39.3602C55.8405 39.0724 55.738 38.7457 55.6625 38.4577C55.61 38.2572 55.5623 38.041 55.5204 37.8514C55.503 37.7726 55.4866 37.6985 55.4714 37.632C55.4116 37.3717 55.3671 37.2228 55.3312 37.1475C55.3262 37.1374 55.3213 37.1272 55.3164 37.1168C55.1541 36.7782 54.9275 36.3051 54.645 35.9353C54.3858 35.596 54.2324 35.5363 54.1723 35.5277Z",
          fill: "#001018"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.5499 11.6H73.4499V46.4H12.5499V11.6ZM13.9999 13.05V44.95H71.9999V13.05H13.9999Z",
          fill: "#EFF1F3"
        }
      )
    ]
  }
);
const VpPaymentCheckAsset = forwardRef(PaymentCheckAsset);

export { VpPaymentCheckAsset as default };
